import {SubmitMissionProgressResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coins/v1/service.types';
import {MissionType} from '../utils/missionType';

const missionConfigs: Record<
  MissionType,
  {
    missionId: number;
    missionTitle: string;
    reward: number;
    congratulationTitle: string;
    congratulationDescription: string;
  }
> = {
  addBirthdayMission: {
    missionId: 1,
    missionTitle: 'Add your birthday',
    reward: 100,
    congratulationTitle: 'Congrats 🎉',
    congratulationDescription:
      "You've added your birthday! Get bonus coins now and a gift on your day.",
  },
  pushNotificationMission: {
    missionId: 2,
    missionTitle: 'Enable push notifications',
    reward: 200,
    congratulationTitle: 'Awesome! 🎊',
    congratulationDescription:
      "You've enabled push notifications! Stay updated on deals and order updates.",
  },
  newsletterMission: {
    missionId: 3,
    missionTitle: 'Join our newsletter',
    reward: 150,
    congratulationTitle: 'Welcome! 🎈',
    congratulationDescription:
      "You've joined our newsletter! Get exclusive deals and bonus coins.",
  },
  likeBrandMission: {
    missionId: 4,
    missionTitle: 'You liked 3 brands!',
    reward: 50,
    congratulationTitle: 'Nice! 🎉',
    congratulationDescription:
      "You've liked a brand! Discover more favorites and earn coins.",
  },
  addToWishlistMission: {
    missionId: 5,
    missionTitle: 'Add 5 items to your wishlist',
    reward: 75,
    congratulationTitle: 'Saved! 🎉',
    congratulationDescription:
      "You've added items to your wishlist! Keep collecting favorites and earn coins.",
  },
  sizeFinderMission: {
    missionId: 6,
    missionTitle: 'Find your size',
    reward: 125,
    congratulationTitle: 'Perfect fit! ✨',
    congratulationDescription:
      "You've completed the size finder! Shop with more confidence and earn coins.",
  },
};

export const submitMissionProgress = (
  missionType: MissionType = 'addBirthdayMission',
): SubmitMissionProgressResponse => {
  const config = missionConfigs[missionType];

  return {
    missionSuccessNotification: {
      title: 'Mission',
      missionStage: {
        title: config.missionTitle,
      },
      congratulationsStage: {
        title: config.congratulationTitle,
        deprecatedDescription: config.congratulationDescription,
        description: {
          text: config.congratulationDescription,
        },
        reward: config.reward,
        cta: {
          label: 'Claim your reward',
        },
      },
      missionIdentifier: {
        missionId: config.missionId,
        tierIndex: 0,
      },
    },
  };
};
